(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__ptTabsInit) return;
    window.__ptTabsInit = true;

    function activate(container, tab, focus) {
      container.querySelectorAll('[role="tab"]').forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
        var panel = container.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      if (focus) tab.focus();
    }

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-product-tabs] [role="tab"]');
      if (!tab) return;
      activate(tab.closest('[data-product-tabs]'), tab, false);
    });

    document.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-product-tabs] [role="tab"]');
      if (!tab) return;
      var tabs = Array.prototype.slice.call(tab.parentNode.querySelectorAll('[role="tab"]'));
      var index = tabs.indexOf(tab);
      var next = null;

      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      else if (event.key === 'Home') next = tabs[0];
      else if (event.key === 'End') next = tabs[tabs.length - 1];

      if (next) {
        event.preventDefault();
        activate(tab.closest('[data-product-tabs]'), next, true);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('auto-slider')) {
    class AutoSlider extends HTMLElement {
      connectedCallback() {
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.delay = (parseFloat(this.dataset.speed) || 4) * 1000;

        this.onQueryChange = () => (this.mobileQuery.matches ? this.start() : this.stop());
        this.onTouchStart = () => this.stop();
        this.onTouchEnd = () => this.onQueryChange();

        this.mobileQuery.addEventListener('change', this.onQueryChange);
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.addEventListener('touchcancel', this.onTouchEnd, { passive: true });

        this.onQueryChange();
      }

      disconnectedCallback() {
        this.stop();
        this.mobileQuery.removeEventListener('change', this.onQueryChange);
        this.removeEventListener('touchstart', this.onTouchStart);
        this.removeEventListener('touchend', this.onTouchEnd);
        this.removeEventListener('touchcancel', this.onTouchEnd);
      }

      start() {
        this.stop();
        if (this.reducedMotion.matches || this.children.length < 2) return;
        this.timer = setInterval(() => this.next(), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      next() {
        const slides = Array.from(this.children);
        const atEnd = this.scrollLeft + this.clientWidth >= this.scrollWidth - 2;

        let target;
        if (atEnd) {
          target = slides[0];
        } else {
          const current = slides.findIndex((s) => s.offsetLeft >= this.scrollLeft - 2);
          target = slides[Math.min(current + 1, slides.length - 1)];
        }

        this.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    customElements.define('auto-slider', AutoSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
